import React from 'react';
import styled, { css } from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import PlayButton from '../../play-button';
import CircleText from '../../svg/w4w-circle-text.svg';

const AboutPlayButton = ({ styles, ...props }) => (
  <AboutPlayButtonWrap styles={styles}>
    <AboutCircleText />
    <PlayButton {...props} />
  </AboutPlayButtonWrap>
);

const AboutPlayButtonWrap = styled.div`
  position: absolute;
  z-index: 1;

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

const AboutCircleText = styled(CircleText)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 210px;
  height: 210px;
  transform: translate(-50%, -50%);
  z-index: -1;

  ${screen.below(bp.mobile, `
    width: 115px;
    height: 115px;
  `)};
`;

export default AboutPlayButton;
